import request from '@/config/axios'

export interface PoolDraftVO {
  id?: number
  supplierId?: number
  supplierName?: string
  status?: number
  name?: string
  keyword?: string
  introduction?: string
  description?: string
  categoryId?: number
  brandId?: number
  picUrl?: string
  sliderPicUrls?: string[]
  sort?: number
  specType?: boolean
  deliveryTypes?: number[]
  deliveryTemplateId?: number
  giveIntegral?: number
  subCommissionType?: boolean
  skus?: any[]
  auditRemark?: string
  spuId?: number
  createTime?: string
}

export const getPoolDraftPage = (params: any) => {
  return request.get({ url: '/product/pool-draft/page', params })
}

export const getPoolDraft = (id: number) => {
  return request.get({ url: '/product/pool-draft/get', params: { id } })
}

export const savePoolDraft = (data: any) => {
  return request.post({ url: '/product/pool-draft/save', data })
}

export const submitPoolDraft = (data: any) => {
  return request.post({ url: '/product/pool-draft/submit', data })
}

export const approvePoolDraft = (data: { id: number }) => {
  return request.post({ url: '/product/pool-draft/approve', data })
}

export const pickPoolDraft = (data: {
  id: number
  shopId: number
  deliveryTemplateId?: number
}) => {
  return request.post({ url: '/product/pool-draft/pick', data })
}

export const rejectPoolDraft = (data: { id: number; auditRemark: string }) => {
  return request.post({ url: '/product/pool-draft/reject', data })
}

export const getSupplierAccount = (supplierId: number) => {
  return request.get({ url: '/product/supplier/account/get', params: { supplierId } })
}

export const createOrResetSupplierAccount = (data: {
  supplierId: number
  username: string
  password: string
}) => {
  return request.post({ url: '/product/supplier/account/create-or-reset', data })
}
